/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { fetchLogindata, setStoreIpAddress } from "../../login/redux/actions";
import { fetchStoredetail } from "../../dashboard/redux/actions";
import { maintainCartdata } from "../../home/redux/actions";
import storage from "redux-persist/lib/storage";
import { useNavigate } from "react-router-dom";
import { getIpaddress } from "../util/Ipaddress";
import { currentLocationInfo } from "../../home/redux/actions";
import { logOutAPI } from "../../login/util/logout";
import { storeConnection } from "../../header/redux/actions";
import { storeChathistory } from "../../header/redux/actions";
import { fetchChatuserlist } from "../../header/redux/actions";
import { setStoreMessageReceived } from "../../chat/redux/actions";

function SessionremovePage(props) {
  const ip_address = useSelector((state)=>state?.login?.ip_address)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // useEffect(() => {
  //   setTimeout(function () {
  //     (async () => checkOnehourormore())();
  //   }, 20);
  //   // eslint-disable-next-line
  // }, [location]);
  useEffect(()=>{
    callGetUserIpAddress();
  },[props?.access_token])

  useEffect(()=>{
    window.addEventListener("online", (e) => {
      callGetUserIpAddress();
    });
  },[])
  const callGetUserIpAddress = async () =>{
    let response = await getIpaddress();
    if(response){
      if(ip_address === undefined || ip_address === ""){
        dispatch(setStoreIpAddress(response.ip));
        console.log("Stores",response)
      }else{
        if(ip_address !== response?.ip){
          await logOutAPI(props?.access_token);
          console.log("user_log_out",response?.ip)
          clearReduxData();
        }
      }
    }
    
  }

  const clearReduxData = () => {
    dispatch(setStoreIpAddress(""));
    props.fetchLogindata({});
    props.fetchStoredetail([]);
    props.maintainCartdata([], {});
    //props.currentLocationInfo({});
    props.fetchChatuserlist([]);
    props.storeConnection({});
    dispatch(setStoreMessageReceived({messages:[], users_id:""}))
    storage.removeItem("persist:persist-store");
    navigate("/");
  };



  return <></>;
}
const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  
});
export default connect(mapStateToProps, {
  fetchLogindata,
  fetchStoredetail,
  maintainCartdata,
  currentLocationInfo,
  storeConnection,
  storeChathistory,
  fetchChatuserlist,
})(SessionremovePage);
